/** A consent sent to the patient's app to sign (patient-platform tasks/patient-email-inbox.md "Consents follow the
 *  email"). `declined` can still appear on a row from before decline was removed; nothing creates one now. */
export interface PatientAppConsentRequest {
  id: string;
  consentId: string;
  status: 'open' | 'signed' | 'declined' | 'withdrawn' | 'expired';
  sentAt: string;
  expiresAt: string;
  decidedAt: string | null;
}

/** The newest request of each consent, by consent id. */
export function latestConsentRequests(requests: readonly PatientAppConsentRequest[]): Record<string, PatientAppConsentRequest> {
  const latest: Record<string, PatientAppConsentRequest> = {};
  for (const r of requests) {
    const id = r.consentId.toLowerCase();
    if (!latest[id] || new Date(r.sentAt).getTime() > new Date(latest[id].sentAt).getTime()) latest[id] = r;
  }
  return latest;
}

const LABEL: Record<PatientAppConsentRequest['status'], string | null> = {
  open: 'Sent to the patient app',
  signed: 'Signed in the patient app',
  declined: 'Declined in the patient app',
  expired: 'Expired in the patient app',
  withdrawn: null,
};

/** What a pending consent says about the patient's app, for display only: there is no send action here any more. */
export function consentAppState(latest: PatientAppConsentRequest | undefined): { label: string | null } {
  return { label: latest ? LABEL[latest.status] : null };
}
